/** Opens the ⌘K search from anywhere, e.g. the "not found" page. The shell listens. */
export const PALETTE_EVENT = 'farmos:palette';
export const openPalette = () => window.dispatchEvent(new Event(PALETTE_EVENT));
